var scope_0 = require('/opt/atlassian/pipelines/agent/build/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/73480643f5b0cf90737cab14d6ef0fd4.js').default;export default
        Object.assign({}, scope_0 )
    